import React from 'react';
import PropTypes from 'prop-types';
import lodash from 'lodash';
import FieldSet from '../../fieldset/FieldSet';
import { EMPTY_GRID_DEFAULT_MESSAGE, } from '../../../modules/Constants';
import Grid from '../../grid/Grid';

class DetailedPreference extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  getHeaders(selectedPreference) {
    let headers = [];
    if (selectedPreference && selectedPreference.customerNotificationChannelPreferences
        && selectedPreference.customerNotificationChannelPreferences.length > 0) {
      const preferences = selectedPreference.customerNotificationChannelPreferences;
      headers = Object.keys(preferences[0]).map(header => ({
        value: header,
        display: lodash.startCase(header),
      }));
    }
    return headers;
  }

  getRows(selectedPreference) {
    const rows = [];
    if (selectedPreference && selectedPreference.customerNotificationChannelPreferences
        && selectedPreference.customerNotificationChannelPreferences.length > 0) {
      const preferences = selectedPreference.customerNotificationChannelPreferences;
      preferences.forEach((preference) => {
        rows.push({
          value: Object.values(preference),
          raw: preference,
        });
      });
    }
    return rows;
  }

  render() {
    const { selectedPreference, } = this.props;
    return (
      <div>
        <div>
          <FieldSet title="Preferences Summary" style={{ maxHeight: '300px', }}>
            <Grid
              headers={this.getHeaders(selectedPreference)}
              rows={this.getRows(selectedPreference)}
              onEmptyGridMessage={EMPTY_GRID_DEFAULT_MESSAGE}
            />
          </FieldSet>
        </div>
      </div>
    );
  }
}

DetailedPreference.defaultProps = {};

DetailedPreference.propTypes = {
  selectedPreference: PropTypes.instanceOf(Object).isRequired,
};

export default DetailedPreference;
